package com.appcreator.dto

enum class AccessLevel: Comparable<AccessLevel> {
    Viewer,
    Editor,
    Admin,
    SuperAdmin
}
